import {
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";

export default function StrategyDropdown({ strategyMode, setStrategyMode }) {

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="strategy-label">
        Select Strategy
      </InputLabel>

      <Select
        labelId="strategy-label"
        value={strategyMode}
        label="Select Strategy"
        onChange={(e) =>
          setStrategyMode(e.target.value)
        }
      >
        <MenuItem value="ALL">
          All Strategies
        </MenuItem>

        <MenuItem value="EMA_ONLY">
          EMA 9/15 Only
        </MenuItem>

        <MenuItem value="EMA_VWAP">
          EMA + VWAP
        </MenuItem>

        <MenuItem value="EMA_BREAKOUT">
          EMA + Breakout
        </MenuItem>
      </Select>
    </FormControl>
  );
}